export default __webpack_public_path__ + "static/media/greeting_card_landscape.2bb3569d.png";